const Dashboard = () => {
    return (
        <div>
            <h1>Welcome to Adzz CRM!</h1>
        </div>
    );
};
export default Dashboard;
